/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { MapCommand } from '../map-command.class';
import { PolygonSelectModePanelComponent } from './polygon-select-mode-panel.component';
import { Injector } from '@angular/core';
import { Dialog } from '@angular/cdk/dialog';
import { Overlay } from '@angular/cdk/overlay';

export class PolygonSelectCommand extends MapCommand {

    private injector: Injector;
    private dialog: Dialog;
    private overlay: Overlay;

    invoke() {
        const dialogRef = this.dialog.open<void>(
            PolygonSelectModePanelComponent, {
                hasBackdrop: false,
                positionStrategy: this.overlay
                    .position().global()
                    .right('10px').bottom('64px'),
            });

        const closeSub = dialogRef.closed.subscribe(() => this.deactivate$.next());
        this.deactivated$.subscribe(() => {
            // closeSub.unsubscribe();
            dialogRef.close();
        });

    }

    protected onCommandInit() {
        super.onCommandInit();
        this.injector = this.deps['injector'];
        this.dialog = this.deps['dialog'];
        this.overlay = this.deps['overlay'];
    }
}
